<template>
  <div class="report-template">
    <h1 class="report-title textMainColor">{{ $t('Open Orders') }}</h1>
    <div class="report-filter-wrapper">
      <div class="report-filter-item">
        <div class="report-filter-item-title">{{ $t('Filter') }}</div>
        <div class="report-filter-item-input-wrap">
          <CustomSelect
              custom-class="support-form"
              :options="filterOptionsList"
              default="All"
              @update:modelValue="formData.type = $event"
              ref="selectFilter"
          />
        </div>
      </div>
      <div class="report-filter-item">
        <div class="report-filter-item-title">{{ $t('Symbol') }}</div>
        <div class="report-filter-item-input-wrap">
          <CustomSelect
              custom-class="support-form"
              :options="symbolOptionsList"
              default="All"
              @update:modelValue="formData.symbol = $event"
              ref="selectSymbol"
          />
        </div>
      </div>
      <div class="report-filter-item">
        <div class="report-filter-item-title">{{ $t('Side') }}</div>
        <div class="report-filter-item-input-wrap">
          <CustomSelect
              custom-class="support-form"
              :options="sideOptionsList"
              default="All"
              @update:modelValue="formData.side = $event"
              ref="selectSide"
          />
        </div>
      </div>
<!--      <div class="report-filter-item">-->
<!--        <div class="report-filter-item-title">{{ $t('Search') }}</div>-->
<!--        <div class="search-input-wrap">-->
<!--          <input-->
<!--              :placeholder="$t('Search')"-->
<!--              class="search-input"-->
<!--              type="search"-->
<!--              name="search-result"-->
<!--              id="search"-->
<!--              v-model="formData.searchedText"-->
<!--              v-debounce:1000ms="changeSelectFilter"-->
<!--          >-->
<!--          <div class="search-icon search">-->
<!--            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M7.33334 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33334C12.6667 4.38782 10.2789 2 7.33334 2C4.38782 2 2 4.38782 2 7.33334C2 10.2789 4.38782 12.6667 7.33334 12.6667Z"-->
<!--                  stroke="#42E8E0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--              <path d="M13.9996 13.9996L11.0996 11.0996" stroke="#42E8E0" stroke-width="1.5" stroke-linecap="round"-->
<!--                    stroke-linejoin="round"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--          <div-->
<!--              v-if="formData.searchedText.length"-->
<!--              class="search-icon reset" @click.stop="resetQuestion">-->
<!--            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--              <path-->
<!--                  d="M2.25 2.25L7.99995 7.99995M7.99995 7.99995L13.7499 2.25M7.99995 7.99995L13.75 13.7498M7.99995 7.99995L2.2501 13.7498"-->
<!--                  stroke="#E9E9E9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>-->
<!--            </svg>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="report-filter-button-wrap">
        <button @click="resetFilterParams">{{ $t('Reset') }}</button>
      </div>
    </div>
    <div class="report-content">
      <div class="preloader new-preloader" v-if="isLoading">
        <lottie-animation
            ref="preloader"
            :animationData="require('@/assets/img/Loader.json')"
            :loop="true"
            :autoPlay="true"
            :speed="1"
        />
      </div>
      <div v-if="!isLoading && isDataEmpty" class="holder-not-logged-text report-empty-wrap">
        <div class="report-empty-list">
          <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.1351 5.89334C41.0418 4.8 39.1484 5.54667 39.1484 7.06667V16.3733C39.1484 20.2667 42.4551 23.4933 46.4818 23.4933C49.0151 23.52 52.5351 23.52 55.5484 23.52C57.0684 23.52 57.8684 21.7333 56.8018 20.6667C52.9618 16.8 46.0818 9.84 42.1351 5.89334Z" fill="#92939C"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M46.9613 27.1733H54.668C56.1346 27.1733 57.3346 28.3733 57.3346 29.84V39.6441C55.2687 38.1884 52.7495 37.3333 50.0315 37.3333C43.0218 37.3333 37.3346 43.0205 37.3346 50.0302C37.3346 53.365 38.6218 56.4005 40.7262 58.6666H21.5213C13.308 58.6666 6.66797 53.3333 6.66797 43.8133V20.1866C6.66797 10.6666 13.308 5.33331 21.5213 5.33331H32.828C34.2946 5.33331 35.4946 6.53331 35.4946 7.99998V15.7066C35.4946 22.0266 40.6413 27.1733 46.9613 27.1733ZM57.3346 43.755V43.8133C57.3346 52.1992 52.1825 57.3365 45.3411 58.4415C42.3948 56.7941 40.4015 53.6436 40.4015 50.0302C40.4015 44.7143 44.7156 40.4002 50.0315 40.4002C52.9509 40.4002 55.5682 41.7013 57.3346 43.755ZM20.0013 47.3333H30.668C31.7613 47.3333 32.668 46.4266 32.668 45.3333C32.668 44.24 31.7613 43.3333 30.668 43.3333H20.0013C18.908 43.3333 18.0013 44.24 18.0013 45.3333C18.0013 46.4266 18.908 47.3333 20.0013 47.3333ZM20.0013 36.6666H36.0013C37.0946 36.6666 38.0013 35.76 38.0013 34.6666C38.0013 33.5733 37.0946 32.6666 36.0013 32.6666H20.0013C18.908 32.6666 18.0013 33.5733 18.0013 34.6666C18.0013 35.76 18.908 36.6666 20.0013 36.6666Z" fill="#92939C"/>
            <path d="M59.9855 57.2476L58.0636 55.3257C59.0655 53.8127 59.6584 51.993 59.6584 50.0302C59.6584 44.7143 55.3443 40.4002 50.0284 40.4002C44.7125 40.4002 40.3984 44.7143 40.3984 50.0302C40.3984 55.3461 44.7125 59.6602 50.0284 59.6602C51.9912 59.6602 53.7905 59.0672 55.3239 58.0654L57.2458 59.9873C57.6343 60.3758 58.125 60.5598 58.6361 60.5598C59.1473 60.5598 59.638 60.3758 60.0264 59.9873C60.742 59.2513 60.742 58.0245 59.9855 57.2476Z" fill="#92939C"/>
          </svg>
          <p class="secondary-text holder-not-logged-text">{{ $t('No records found') }}</p>
        </div>
      </div>
      <table v-if="tradingTableInfoOpenOrders.length" class="report-open-orders-table">
        <thead class="holder-table">
          <tr class="table-head">
            <!-- 1 -->
            <td class="pair" :data-label="$t('Symbol')">
              <p>
                <span class="textSecondaryColor">{{ $t('Symbol') }}</span>
              </p>
            </td>
            <!-- 2 -->
            <td class="type" :data-label="$t('type')">
              <p>
                <span class="textSecondaryColor">{{ $t('type') }}</span>
              </p>
            </td>
            <!-- 3 -->
            <td class="amount" :data-label="$t('amount' + ' / ' + 'Filled')">
              <p>
                <span class="textSecondaryColor">{{ $t('amount') }} / {{ $t('Filled') }}</span>
              </p>
            </td>
            <!-- 4 -->
            <td class="price" :data-label="$t('priceTextPrice')">
              <p>
                <span class="textSecondaryColor">{{ $t('priceTextPrice') }}</span>
              </p>
            </td>
            <!-- 5 -->
            <td class="side" :data-label="$t('Side')">
              <p>
                <span class="textSecondaryColor">{{ $t('Side') }}</span>
              </p>
            </td>
            <!-- 7 -->
            <td class="notional-value" :data-label="$t('Notional Value')">
              <p>
                <span class="textSecondaryColor">{{ $t('Notional Value') }}</span>
              </p>
            </td>
            <!-- 8 -->
            <td class="placed" :data-label="$t('accordeonOptionsPlaced')">
              <p>
                <span class="textSecondaryColor">{{ $t('accordeonOptionsPlaced') }}</span>
              </p>
            </td>
            <!-- last -->
            <!--                <td :style="{'visibility': isCheckedOrders ? 'visible' : 'hidden'}" class="holder-checkbox" style="width: 5%;">-->
            <!--                  <label class="orange-checkbox-container">-->
            <!--                    <input-->
            <!--                        type="checkbox"-->
            <!--                        :checked="isCheckedOrders"-->
            <!--                        @click="handleCheckedOrders"-->
            <!--                    />-->
            <!--                    <span class="checkmark"></span>-->
            <!--                  </label>-->
            <!--                </td>-->
            <!-- 7 -->
            <td v-if="tradingTableInfoOpenOrders.length" style="width: 5%; text-align: right"
                @click="onDeleteTradingOrderAll()">
              <button data-v-58e160a4="" type="button">
                <svg data-v-58e160a4="" width="16" height="16" viewBox="0 0 16 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path data-v-58e160a4=""
                        d="M2.25 2.25L7.99995 7.99995M7.99995 7.99995L13.7499 2.25M7.99995 7.99995L13.75 13.7498M7.99995 7.99995L2.2501 13.7498"
                        stroke="#A4A5AF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </button>
            </td>
          </tr>
        </thead>
        <tbody class="open-orders-table-main">
        <TradingOpenOrdersItems
            v-for="(openOrder, index) in tradingTableInfoOpenOrders"
            :key="index"
            :openOrdersItems="openOrder"
            :isCheckedOrders="isCheckedOrders"
            @onDeleteOrder="onDeleteTradingOrder"
        />
        </tbody>
      </table>
      <b-pagination-nav
          v-if="!isLoading && tradingTableInfoOpenOrders.length && count !== 1"
          v-model="page"
          :link-gen="linkGen"
          :number-of-pages="count"
          :per-page="pageSize"
          :total-rows="count"
          class="pagination"
          first-number
          last-number
          next-text="»"
          prev-text="«"
          use-router
      />
    </div>
    <InfoDialog
        ref="infoDialog"
        :title="infoDialogData.dialogTitle"
        :text="infoDialogData.dialogText"
        :confirmBtnText="infoDialogData.confirmBtnText"
        :cancelBtnText="infoDialogData.cancelBtnText"
        @onConfirm="deleteOrder"
    />

    <InfoDialog
        ref="infoDialogDeleteOrderAll"
        :title="infoDialogData.dialogTitle"
        :text="infoDialogData.dialogText"
        :confirmBtnText="infoDialogData.confirmBtnText"
        :cancelBtnText="infoDialogData.cancelBtnText"
        @onConfirm="cancelOrderAll"
    />
  </div>
</template>

<script>
import LottieAnimation from "lottie-web-vue";
import TradingOpenOrdersItems from './open-orders/TradingOpenOrdersItems';
import CustomSelect from '../inputs/CustomSelect';
import InfoDialog from '../popups/InfoDialog';
import { mapActions } from 'vuex';

export default {
  name: 'ReportsOpenOrders',
  data() {
    return {
      isCheckedOrders: false,
      filterOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'Limit',
          value: 'LIMIT',
        },
        // {
        //   name: 'Market',
        //   value: 'MARKET',
        // },
        ],
      symbolOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'BTC/USDT',
          value: 'btc_usdt',
        },
        {
          name: 'ETH/USDT',
          value: 'eth_usdt',
        },
        {
          name: 'SOL/USDT',
          value: 'sol_usdt',
        },
        {
          name: 'ADA/USDT',
          value: 'ada_usdt',
        },
        {
          name: 'NEAR/USDT',
          value: 'near_usdt',
        },
        {
          name: 'APE/USDT',
          value: 'ape_usdt',
        },
        {
          name: 'ATOM/USDT',
          value: 'atom_usdt',
        },
        {
          name: 'AVAX/USDT',
          value: 'avax_usdt',
        },
        {
          name: 'DOT/USDT',
          value: 'dot_usdt',
        },
        {
          name: 'GMT/USDT',
          value: 'gmt_usdt',
        },
        {
          name: 'MATIC/USDT',
          value: 'matic_usdt',
        },
      ],
      sideOptionsList: [
        {
          name: 'All',
          value: '',
        },
        {
          name: 'Buy',
          value: 'BUY',
        },
        {
          name: 'Sell',
          value: 'SELL',
        }],
      tradingTableInfoOpenOrders: [],
      walletAddress: null,
      counters: {},
      infoDialogData: {},
      isLoading: true,
      isDataEmpty: false,
      openOrderItems: [],
      formData: {
        type: '',
        symbol: '',
        side: '',
        searchedText: '',
      },
      page: 1,
      count: null,
      pageSize: 20,
    };
  },
  watch: {
    'formData.type'() {
      this.changeSelectFilter();
    },

    'formData.side'() {
      this.changeSelectFilter();
    },

    'formData.symbol'() {
      this.changeSelectFilter();
    },
    '$route.query.page': {
      deep: true,
      handler(newVal) {
        if(newVal) {
          this.page = newVal;
          this.getOpenOrdersData();
        } else {
          this.page = 1;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getOrdersReportOpen: 'orders/getOrdersReportOpen',
      deleteOrderById: 'orders/deleteOrderById',
      deleteOrderAll: 'orders/deleteOrderAll'
    }),
    prettify(num) {
      num = Number(num).toLocaleString("en-US")
      return num
    },
    linkGen(pageNum) {
      return {
        path: '/reports/open-orders',
        query: { page: pageNum },
      };
    },
    resetPagination() {
      this.$router.push({path: '/reports/open-orders', query: { page: 1 }}).catch(() => {});
    },
    changeSelectFilter() {
      this.resetPagination()
      if(this.page === 1) {
        this.getOpenOrdersData();
      }
    },
    resetQuestion() {
      this.formData.searchedText = '';
      this.getOpenOrdersData();
    },
    resetFilterParams() {
      this.formData.searchedText = '';
      this.formData.type = '';
      this.formData.symbol = '';
      this.formData.side = '';
      this.resetPagination()
      if(this.page === 1) {
        this.getOpenOrdersData();
      }

      this.resetFilterToDefault();
    },
    resetFilterToDefault() {
      this.$refs.selectFilter.reset();
      this.$refs.selectSymbol.reset();
      this.$refs.selectSide.reset();
    },

    deleteOrder(order) {
      if (order.length) {
        order.forEach((item) => {
          this.deleteOrderById({
            derUuid: item.orderData[0].id,
            orderType: item.orderData[0].id
          }).then(() => {});
        });
      } else {
        this.deleteOrderById({
          orderId: order.id,
          symbol: order.symbol
        }).then(() => {
          this.getOpenOrdersData();
        }); //add logic for dialog close
      }
    },
    cancelOrderAll() {
      this.deleteOrderAll().then(() => {
        this.openOrderItems = [];
        this.getOpenOrdersData();
      });
    },
    onDeleteTradingOrder(order) {
      this.infoDialogData = {
        dialogTitle: `Cancel ${order.length ? 'orders' : 'order'}`,
        dialogText: `Are you sure you want to cancel ${order.length ? order.length +' orders' : 'order'}?`,
        confirmBtnText: 'Yes',
        cancelBtnText: 'No'
      }
      this.$refs.infoDialog.showDialog(order);
    },
    onDeleteTradingOrderAll() {
      this.infoDialogData = {
        dialogTitle: `Cancel orders`,
        dialogText: `Are you sure you want to cancel orders?`,
        confirmBtnText: 'Yes',
        cancelBtnText: 'No'
      }

      this.$refs.infoDialogDeleteOrderAll.showDialog();
    },
    getRequestParams(formData) {
      const params = {};

      for (const data in formData) {
        if (formData[data].length) {
          params[data] = formData[data];
        }
      }

      return params;
    },
    getOpenOrdersData() {
      this.isLoading = true;
      this.isDataEmpty = false;
      this.tradingTableInfoOpenOrders = [];
      const params = this.getRequestParams(this.formData)

      params.size = this.pageSize
      params.page = this.page - 1

      this.getOrdersReportOpen({params}).then((data) => {
        this.tradingTableInfoOpenOrders = data.content
        this.counters.tradingTableInfoOpenOrders = this.tradingTableInfoOpenOrders.length;
        this.count = data.totalPages
        this.isLoading = false;
        if(!this.tradingTableInfoOpenOrders.length) {
          this.isDataEmpty = true;
        }
      });
    },
  },
  mounted() {
    this.page = +this.$route.query.page || 1;
    this.getOpenOrdersData();
  },
  components: {
    LottieAnimation,
    CustomSelect,
    TradingOpenOrdersItems,
    InfoDialog
  }
};
</script>

<style lang="scss">

.open-orders-table-main {
  width: 100%;
}

.report-open-orders-table .holder-table {
  margin-top: 0;
}

.v-application.theme--dark .report-open-orders-table .holder-table {
  margin-top: 0;
  border-bottom: none !important;
}


.report-open-orders-table {
  width: 100%;

  p {
    padding-left: 0px;
    margin-bottom: 0;
    padding: 12px 0px;
  }

  .up {
    top: 4px;
    left: 0;
  }

  .down {
    bottom: 4px;
    left: 0;
  }

  .pair {
    width: 10%;
  }

  .amount {
    text-align: right;
    width: 10%;
  }

  .side {
    text-align: center;
    width: 10%;
  }

  .filled {
    text-align: right;
    width: 10%;
  }

  .type {
    text-align: left;
    width: 10%;
  }

  .price {
    text-align: right;
    width: 15%;
  }

  .notional-value {
    text-align: right;
    width: 15%;
  }

  .placed {
    text-align: left;
    width: 20%;
    padding-left: 50px;
  }

  .table-head {
    .notional-value p {
      text-align: right;
    }

    .price p {
      text-align: right;
    }

    .filled p {
      text-align: right;
    }

    .notional-value p {
      text-align: right;
    }

    .amount p {
      text-align: right;
    }

    .side p {
      text-align: center;
    }
  }
}
</style>
